// Shared camera framing distances, written by ResponsiveRig and read by the
// FocusTourController.
export const camRig = { dist: 8, focusDist: 4 };
